import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/document-agent')({
  beforeLoad: ({ context, params }) => {
    const features = context.user.userOrgProfile?.enabled_features
    const enabled = (features?.proposal_agent ?? false) || (features?.presentation_agent ?? false)
    if (!enabled) {
      throw redirect({
        to: '/$orgSlug/$projectId/content/text',
        params: { orgSlug: params.orgSlug, projectId: params.projectId }
      })
    }
  },
  component: DocumentAgentLayout
})

function DocumentAgentLayout() {
  return <Outlet />
}
